import React, { useMemo } from "react";
import KC_UIText from "../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../designsystem/ds_commons";
import "./styles.scss";
interface SidebarIProps {
  icon?: JSX.Element;
  text: string;
  isSelected: boolean;
  className?: string;
  onClickItem: () => void;
}
export default function SideBarItem(props: SidebarIProps) {
  const bootstrapCls = ["d-flex", "w-100"];
  const dsCls = ["st-gap"];
  const cls: string = useMemo(() => {
    return [
      "dashboard-side-bar-item",
      ...bootstrapCls,
      ...dsCls,
      props.className,
      props.isSelected ? "item-selected" : "item-unselected"
    ]
      .filter(Boolean)
      .join(" ");
  }, [props.isSelected, props.className, bootstrapCls, dsCls]);
  return (
    <div className={cls} onClick={props.onClickItem}>
      <span>{props.icon}</span>
      <KC_UIText weight={KC_Weights.reg} text={props.text} />
    </div>
  );
}
